import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class Popup extends React.Component {
  constructor(props) {
    super(props);

    this.el = document.createElement('div');
    this.el.setAttribute('id', 'popup'+props.index);
    this.el.setAttribute('style', 'pointer-events: none; position:absolute;height:100%;width:100%; top:0px; right:0; bottom:30px;left:0; z-index:'+props.zDepth);
  }

  componentDidMount() {
    // 
    document.querySelector('#popup-container').appendChild(this.el);
  }

  componentWillUnmount() {
    // 
    //document.querySelector('#popup-container').removeChild(this.el);
  }

  render() {
    
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

Popup.propTypes = {
  children: PropTypes.element,
};

export default Popup;
